export const MyLearningCardType = {
    PAST_DUE_STATE: 'pastDueState',
    DUE_NEXT_STATE: 'dueNextState',
    COMPLETE_PENDING_SURVEY: 'completePendingSurvey',
    NO_ASSIGNMENTS_DUE: 'noAssignmenstDue',
    NO_ASSIGNMENTS_ASSIGNED: 'noAssignmentsAssigned',
};
